import Hero from "views/components/pages/PharmacyAI/Hero";
import Products from "views/components/pages/PharmacyAI/Products";
import WhatWeDo from "views/components/pages/PharmacyAI/WhatWeDo";
import IrelandSection from "views/components/pages/PharmacyAI/IrelandSection";
import TrustCards from "views/components/pages/PharmacyAI/TrustCards";
import styled from "styled-components";

const PageWrapper = styled.div`
  background: #fafbfc;
  min-height: 100vh;
`;

const PharmacyAi = () => {
  return (
    <PageWrapper>
      <Hero />
      <Products />
      <WhatWeDo />
      <IrelandSection />
      <TrustCards />
    </PageWrapper>
  );
};

export default PharmacyAi;
